import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=3f1692d0&scoped=true&"
import script from "./Coverage.vue?vue&type=script&lang=js&"
export * from "./Coverage.vue?vue&type=script&lang=js&"
import style0 from "./Coverage.vue?vue&type=style&index=0&id=3f1692d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1692d0",
  null
  
)

export default component.exports